import CustomUnderline from "./CustomUnderline";
import Dashboard from "./Dashboard";
import InfoIcon from "./InfoIcon";
import MessageIcon from "./MessageIcon";
import NotificationBell from "./NotificationBell";
import PredictiveMaintenance from "./PredictiveMaintenance";
import ReportSummary from "./ReportSummary";
import SenszLogo from "./SenszLogo";
import SettingsIcon from "./SettingsIcon";
import SideDownArrow from "./SideDownArrow";
import SideDropArrow from "./SideDropArrow";
import Subscribe from "./Subscribe";

import CtmBinIcon from "./CtmBinIcon";

export default {
  SideDropArrow,
  Subscribe,
  PredictiveMaintenance,
  ReportSummary,
  Dashboard,
  SenszLogo,
  SettingsIcon,
  NotificationBell,
  MessageIcon,
  CustomUnderline,
  SideDownArrow,
  InfoIcon,
  CtmBinIcon,
};
